(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-highlight"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__shhInit) return;
    window.__shhInit = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var headings = Array.prototype.slice.call(document.querySelectorAll('[data-shh-heading]')).map(function (heading) {
      heading.classList.add('shh-ready');
      return {
        el: heading,
        words: Array.prototype.slice.call(heading.querySelectorAll('[data-shh-word]'))
      };
    });
    if (!headings.length) return;

    function clamp01(n) { return Math.min(1, Math.max(0, n)); }

    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      var start = vh * 0.85;
      var end = vh * 0.45;
      headings.forEach(function (heading) {
        var rect = heading.el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = clamp01((start - rect.top) / (start - end));
        var revealCount = Math.round(progress * heading.words.length);
        heading.words.forEach(function (word, i) {
          word.classList.toggle('is-lit', i < revealCount);
        });
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { capture: true, passive: true });

    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
